import React, { useEffect } from 'react';
import Logo from '../assets/img/logo.png';
import LoginInput from '../components/LoginInput';
import { useState } from 'react';
import { FaEnvelope, FaLock, FcGoogle } from '../assets/icons'
import { motion } from "framer-motion";
import { buttonClick } from '../animations';
import { getAuth, signInWithPopup, GoogleAuthProvider, createUserWithEmailAndPassword, signInWithEmailAndPassword, FacebookAuthProvider } from "firebase/auth";
import { app, firestore } from "../config/firebase.config";
import { validateUserJWTToken } from '../api';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setUserDetails, setUserNull } from '../context/actions/userActions';
import { alertInfo, alertNULL, alertSuccess, alertWarning } from '../context/actions/alertActions';
import { FaFacebook } from 'react-icons/fa';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const LoginContainer = () => {

    const [userEmail, setUserEmail] = useState("");
    const [isSignUp, setIsSignUp] = useState(false);
    const [passWord, setPassWord] = useState("");
    const dispatch = useDispatch();
    const [confirm_password, setConfirm_password] = useState("");
    const navigate = useNavigate();
    const user = useSelector(state => state.user);
    const firebaseAuth = getAuth(app);
    const provider = new GoogleAuthProvider();
    const facebookProvider = new FacebookAuthProvider();
    useEffect(() => {
        if (user) {
            navigate("/", { replace: true })
            window.location.reload();  // Reload the page after navigating
        }
    }, [user, navigate])

    // const signOut = () => {
    //     firebaseAuth
    //         .signOut()
    //         .then(() => {
    //             navigate("/login", { replace: true })
    //         })
    //         .catch((err) => console.log(err));
    // }

    const signUpWithEmailPass = async () => {
        if ((userEmail === "" || passWord === "" || confirm_password === "")) {
            dispatch(alertInfo('Required fields should not empty'))
        } else {
            if (passWord === confirm_password) {
                setUserEmail("")
                setConfirm_password("");
                setPassWord("");
                // alert message
                await createUserWithEmailAndPassword(firebaseAuth, userEmail, passWord).then(userCred => {
                    firebaseAuth.onAuthStateChanged((cred) => {
                        if (cred) {
                            cred.getIdToken().then(token => {
                                validateUserJWTToken(token).then(data => {
                                    dispatch(setUserDetails(data));
                                })
                            })
                        }
                    })
                })
            } else {
                // alert message
                dispatch(alertWarning("Password doesn't match"))
            }
        }
    }


    const signInWithEmailPass = async () => {
        if (userEmail !== "" || passWord !== "") {
            await signInWithEmailAndPassword(firebaseAuth, userEmail, passWord).then(userCred => {
                firebaseAuth.onAuthStateChanged((cred) => {
                    if (cred) {
                        cred.getIdToken().then(token => {
                            validateUserJWTToken(token).then(data => {
                                dispatch(setUserDetails(data))
                            });
                            navigate("/", { replace: true });
                        })
                    }
                })
            })
        } else {
            // alert message
            dispatch(alertWarning("Password doesn't match"))
        }
    }
    const signInWithFacebook = async () => {
        try {
            const result = await signInWithPopup(firebaseAuth, facebookProvider); // Use Facebook provider
            if (result.user) {
                const token = await result.user.getIdToken();
                validateUserJWTToken(token).then((data) => {
                    dispatch(setUserDetails(data));
                    dispatch(alertSuccess(`Hi, ${data.name}`));
                });
                navigate("/", { replace: true });
            }
        } catch (error) {
            if (error.code === "auth/cancelled-popup-request") {
                // Handle the cancellation gracefully, e.g., show a message to the user.
                console.error("Facebook sign-in was cancelled by the user.");
            } else {
                // Handle other errors
                console.error("Facebook sign-in error:", error);
            }
        }
    };
    const signInWithGoogle = async () => {
        dispatch(setUserNull(null));
        try {
            const result = await signInWithPopup(firebaseAuth, provider);
            if (result.user) {
                const uid = result.user.uid;
                const userRef = doc(firestore, "users", uid);
                const userDoc = await getDoc(userRef);

                if (!userDoc.exists()) {
                    const defaultUserData = {
                        displayName: result.user.displayName,
                        email: result.user.email,
                        role: "user",
                        photoURL: result.user.photoURL,
                        uid: uid,
                        address: null,
                    };
                    await setDoc(userRef, defaultUserData);
                }

                const token = await result.user.getIdToken();
                await validateUserJWTToken(token).then((data) => {
                    dispatch(setUserDetails(data));
                    dispatch(alertSuccess(`Hi, ${data.displayName}`));
                    setTimeout(() => {
                        dispatch(alertNULL());
                    }, 3000);
                });

                navigate("/", { replace: true });
            }
        } catch (error) {
            if (error.code === "auth/cancelled-popup-request") {
                console.error("Google sign-in was cancelled by the user.");
            } else {
                console.error("Google sign-in error:", error);
            }
        }
    };

    return (
        <div className='w-screen h-screen relative overflow-hidden flex'>
            <img src="https://img.rawpixel.com/s3fs-private/rawpixel_images/website_content/v1016-c-08_1-ksh6mza3.jpg?w=800&dpr=1&fit=default&crop=default&q=65&vib=3&con=3&usm=15&bg=F4F4F3&ixlib=js-2.2.1&s=f584d8501c27c5f649bc2cfce50705c0" alt="" className='w-full h-full object-cover absolute top-0 left-0'

            />
            <div className='flex flex-col items-center bg-slate-300 w-[80%] md:w-508 h-full z-10 backdrop-blur-2xl p-4 px-4 py-12'>
                <div className='flex items-center justify-start gap-4 w-full'>
                    <img src={Logo} className='w-24' alt="" />
                </div>
                <p className='text-3xl font-semibold text-headingColor'>Chào mừng bạn !
                </p>
                <p className='text-xl text-textColor'>{isSignUp ? "Sign Up" : "Sign In"} tham gia cùng Doha nhé !</p>
                <div className='w-full flex flex-col items-center justify-center gap-6 px-4 md:px-12 py-4'>
                    <LoginInput placeHolder={"Email Here"}
                        icon={<FaEnvelope className='text-xl text-textColor' />}
                        inputState={userEmail} inputStateFunc={setUserEmail} type="email" isSignUp={isSignUp} />
                    <LoginInput placeHolder={"Password Here"}
                        icon={<FaLock className='text-xl text-textColor' />}
                        inputState={passWord} inputStateFunc={setPassWord} type="passWord" isSignUp={isSignUp} />

                    {isSignUp && (
                        <LoginInput placeHolder={"Confirm Password Here"}
                            icon={<FaLock className='text-xl text-textColor' />}
                            inputState={confirm_password} inputStateFunc={setConfirm_password} type="passWord" isSignUp={isSignUp} />
                    )}

                    {!isSignUp ? (<p>Chưa có tài khoản? {" "}
                        <motion.button {...buttonClick}
                            className="text-red-400 underline cursor-pointer bg-transparent"
                            onClick={() => setIsSignUp(true)}
                        > Tạo tài khoản </motion.button></p>) :
                        (<p>
                            Đã có tài khoản ?: {" "}
                            <motion.button {...buttonClick}
                                className="text-red-400 underline cursor-pointer bg-transparent"
                                onClick={() => setIsSignUp(false)}
                            >
                                Đăng nhập
                            </motion.button>
                        </p>
                        )}
                    {isSignUp ? <motion.button {...buttonClick} className='w-full px-4 py-2 bg-red-400 rounded-md cursor-pointer text-white text-xl capitalize hover:bg-red-500 transition-all ease-in-out duration-150'
                        onClick={signUpWithEmailPass}
                    >
                        Đăng ký
                    </motion.button> :
                        <motion.button {...buttonClick} className='w-full px-4 py-2 rounded-full bg-red-400 cursor-pointer text-white text-xl capitalize hover:bg-red-500 transition-all ease-in-out duration-150'
                            onClick={signInWithEmailPass}
                        >
                            Đăng nhập
                        </motion.button>
                    }
                </div>
                <div className='flex items-center justify-between gap-16 mb-2'>
                    <div className='w-24 h-[1px] rounded-md bg-white'></div>
                    <p className='text-white'>or</p>
                    <div className='w-24 h-[1px] rounded-md bg-white'></div>
                </div>
                <motion.div {...buttonClick} className='flex items-center justify-center px-20 py-2 bg-gray-200 backdrop-blur-md cursor-pointer rounded-3xl gap-4'
                >
                    <FcGoogle className='text-3xl' />
                    <p className='capitalize text-base text-textColor'
                        onClick={signInWithGoogle}
                    >Đăng nhập với Google</p>
                </motion.div>
                <motion.div {...buttonClick} className='mt-10 flex items-center justify-center px-20 py-2 bg-gray-200 backdrop-blur-md cursor-pointer rounded-3xl gap-4'
                >
                    <FaFacebook className='text-3xl' />
                    <p className='capitalize text-base text-textColor' onClick={signInWithFacebook}>
                        Đăng nhập với Facebook
                    </p>
                </motion.div>

            </div>
        </div>
    )
}

export default LoginContainer